const eventImg = [
  {
    img: 'https://i.imgur.com/2juVkDF.jpg',
    name: 'women dancing',
  },
  {
    img: 'https://i.imgur.com/p9TaZUS.jpg',
    name: 'women dancing',
  },
  {
    img: 'https://i.imgur.com/EnH8JGc.jpg',
    name: 'women at a party',
  },
  {
    img: 'https://i.imgur.com/KmiFh9l.jpg',
    name: 'child dancing',
  },
  {
    img: 'https://i.imgur.com/RV5xQ2J.jpg',
    name: 'wrestler celebrating',
  },
  {
    img: 'https://i.imgur.com/abEu1FD.jpg',
    name: 'women`s prize for fiction',
  },
  {
    img: 'https://i.imgur.com/5XtsXqw.jpg',
    name: 'garsington opera',
  },
  {
    img: 'https://i.imgur.com/p8jGEIV.jpg',
    name: 'coca cola',
  },
  {
    img: 'https://i.imgur.com/fQQK5Iv.jpg',
    name: 'women dancing',
  },
  {
    img: 'https://i.imgur.com/6fhBO3U.jpg',
    name: 'child celebrating',
  },
  {
    img: 'https://i.imgur.com/VfQsohW.jpg',
    name: 'couple smiling',
  },
  {
    img: 'https://i.imgur.com/v9cSTJA.jpg',
    name: 'fashion show',
  },
  {
    img: 'https://i.imgur.com/nAcgVTT.jpg',
    name: 'people dancing in a nightclub',
  },
  {
    img: 'https://i.imgur.com/A8G3lLs.jpg',
    name: 'award ceremony speech',
  },
  {
    img: 'https://i.imgur.com/tQhSxii.jpg',
    name: 'women laughing',
  },
  {
    img: 'https://i.imgur.com/POVYfAw.jpg',
    name: 'people dancing',
  },
  {
    img: 'https://i.imgur.com/hkRxA0e.jpg',
    name: 'male dancing',
  },
  {
    img: 'https://i.imgur.com/2ewxWxP.jpg',
    name: 'women in a green room',
  },
  {
    img: 'https://i.imgur.com/WwDnYDZ.jpg',
    name: 'women celebrating',
  },
  {
    img: 'https://i.imgur.com/akxys0E.jpg',
    name: 'man gives a speech',
  },
  {
    img: 'https://i.imgur.com/shqjEFh.jpg',
    name: 'women with facepaint',
  },
  {
    img: 'https://i.imgur.com/ij5mPdB.jpg',
    name: 'india cricket fans',
  },
  {
    img: 'https://i.imgur.com/BtrzNh2.jpg',
    name: 'women playing catch',
  },
  {
    img: 'https://i.imgur.com/oZs8vbK.jpg',
    name: 'people walking',
  },
  {
    img: 'https://i.imgur.com/PdgF9jp.jpg',
    name: 'boy smiling',
  },
  {
    img: 'https://i.imgur.com/sYpcmCG.jpg',
    name: 'public live performance',
  },
  {
    img: 'https://i.imgur.com/CtnQfhe.jpg',
    name: 'guided walk',
  },
  {
    img: 'https://i.imgur.com/okM0ffE.jpg',
    name: 'fireworks display',
  },
  {
    img: 'https://i.imgur.com/LcFbXQ9.jpg',
    name: 'women in fancy-dress',
  },
  {
    img: 'https://i.imgur.com/7fCf9eu.jpg',
    name: 'women giving a speech',
  },
];

export default eventImg;
